import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { ROUTES } from '@futrli/shared-services';

import { DashboardsContainer } from '../dashboards-container';

export const DashboardsRoutingContainer = () => {
  return (
    <Routes>
      <Route path={ROUTES.PERFORMANCE_DASHBOARDS} element={<DashboardsContainer />} />
      <Route path={ROUTES.DASHBOARDS_LIST} element={<DashboardsContainer />} />
      <Route path={ROUTES.DASHBOARD_TEMPLATES} element={<DashboardsContainer />} />
      <Route path="/" element={<DashboardsContainer />} />
      <Route path="*" element={<DashboardsContainer />} />
    </Routes>
  );
};
